import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DashboardPageComponent from './DashboardPageComponent';

import coreActions from '../core/actions';
import dashboardActions from './actions/DashboardActions';
import * as newProductActions from '../products/actions/new-product/NewProductActions';

const allActions = { ...coreActions, ...newProductActions, ...dashboardActions };

const mapStateToProps = ({ config, dashboard, account }) => ({
  config,
  dashboard,
  account,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(allActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPageComponent);
